import { GridCellProps } from "@progress/kendo-react-grid";
import CircleColor from "../../commons/components/CircleColor";

export default function FamilleWebCell(props: GridCellProps) {
    return <td colSpan={1} className="k-table-td" role="gridcell" aria-colindex={2} aria-selected="false" data-grid-col-index="1"><CircleColor colors={props.dataItem.couleurs} editMode={"famille"}/></td>;
}